import { createAsyncThunk} from '@reduxjs/toolkit';

import axios  from 'config/axios';
import { 
  setErrors,
  setDimensions,
  setCompanyDimensions,
  setVAPTDimensions,
  setAvailableDimensions,
  setSeverities,
  setThreatActors,
  setMitreMappings
  } from 'stores/modules/vapt/datareducer';

// eslint-disable-next-line no-empty-pattern
export const fetchVAPTDimensions = createAsyncThunk('vaptData/fetchDimensions', async ({ },{ dispatch }) => {
  try {
    dispatch(setDimensions([]));
    setErrors([]);
    
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/dimensions`, { 
    });
    if (response.status === 200){
      dispatch(setDimensions(response.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchCompanySpecificVAPTDimensions = createAsyncThunk('vaptData/fetchCompanyDimensions', async ({params},{ dispatch }) => {
  try {
    dispatch(setCompanyDimensions([]));
    setErrors([]);
    
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/getSavedCompanyDimensions`, { 
      params:params
    });
    if (response.status === 200){
      dispatch(setCompanyDimensions(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const saveCompanyDimensions = async(data)=>{
  try{
    const response = await axios.post(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/saveCompanyDimension`,data,{
      'Content-Type': 'application/json',
    });
    return response;
  }catch(error){
    return error
  }
}

export const fetchCompanyVAPTDimensions =  async ({params}) => {
  try {    
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/getSavedCompanyDimensions`, { 
      params:params
    });
    if (response.status === 200){
      return response?.data?.data;
    }
  } catch (error) {
  }
};
// eslint-disable-next-line no-empty-pattern
export const fetchDimensionsVAPT = createAsyncThunk('vaptData/fetchDimensionsvapt', async ({},{ dispatch }) => {
  try {
    dispatch(setVAPTDimensions([]));
    setErrors([]);
    
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/categories`, { 
     
    });
    if (response.status === 200){
      dispatch(setVAPTDimensions(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchAvailableDimensions = createAsyncThunk('data/fetchAvailableDimensions', async ({ params, idToken }, { dispatch }) => {
  try {
    const updatedParams = { ...params };
    let response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/available-dimensions`, {
      params: updatedParams,
    });
    dispatch(setAvailableDimensions(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchSeverities = createAsyncThunk('company/fetchSeverities', async ({ idToken }, { dispatch }) => {
  try {
    dispatch(setSeverities([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_VAPT_SEVERITY_ENDPOINT_URL}/severities`, {});
    const severities = response.data.sort((a, b) => {
      if (a.grade < b.grade) {
        return -1;
      }
      if (a.grade > b.grade) {
        return 1;
      }
      return 0;
    });
    dispatch(setSeverities(severities));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchOverAllScore = async ({params}) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/overall-score`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
  }
};

export const fetchOverAllScoreById = async ({params}) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/overall-scoreByCompanyID`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
  } catch (error) {
    
  }
};

export const fetchDomainsPerfomance = async ({  params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/domain-performance`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchThreatActors = createAsyncThunk('data/fetchThreatActors', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setThreatActors([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/apt-list`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setThreatActors(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchThreatActorsById = createAsyncThunk('data/fetchThreatActors', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setThreatActors([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/apt-listByCompany`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setThreatActors(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});
export const fetchAlertAnalysis = async ({ params }) => {
  try {
    let response;

    response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-analysis`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
    // dispatch(setErrors(error.response));
  }
};

export const fetchAlertAnalysisById = async ({ params }) => {
  try {
    let response;

    response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-analysisByCompanyid`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
  } catch (error) {
  }
};

export const fetchAlertsTrend = async ({ idToken, params }) => {
  try {
    let response;
    if (params.compliance){
      delete params.compliance;
      response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trend`, {
        params: params,
      });
    }
    else {
      response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trend`, {
        params: params,
      });
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchAlertsTrendByCompany = async ({ idToken, params }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trendByCompany`, {
        params: params,
      });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateDimensionById = async(dimensionId,{body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/dimension/`+dimensionId,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}

export const saveNewDimension= async({body, params})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/createDimension`,body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      params: params
    },
  );
   return response;
  }catch(error){
    return error.response;
  }

}

export const fetchDimensionsByCategory = async ({ params }) => {
  try {    
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/getDimensionsByCategory`, {params});
    
    if (response.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    console.error("Error fetching dimensions:", error);
  }
};

export const fetchVAPTSubDimensionsByDimensionId = async({dimensionId})=>{
  try{
    let response = await axios.get(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/subdimensionsBydimension/`+dimensionId,{
    })
    return response;
  }catch(error){
    return error;   
  }
  
}

export const saveNewSubDimensionByDimension= async({dimension,body})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/createSubdimension?dimension=`+dimension,body,
    {
      'Content-Type': 'application/json',
    });
   return response;
  }catch(error){
    return error.response;
  }
}

export const updateDimensionweightages = async({body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_VAPT_DIMENSION_ENDPOINT_URL}/dimensions/update-weights`,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}

export const fetchMitreMappings = createAsyncThunk('vaptData/fetchMitreMappings', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setMitreMappings([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_VAPT_DASHBOARD_ENDPOINT_URL}/dashboard/mitremapping`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setMitreMappings(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});